import React from 'react';
import { motion } from 'framer-motion';
import { Wrench, Rocket, Target, TrendingUp } from 'lucide-react';
export function Slide3() {
  const nodes = [{
    id: 1,
    label: 'Build',
    sub: 'from existing assets',
    icon: Wrench,
    x: 50,
    y: 15
  }, {
    id: 2,
    label: 'Launch',
    sub: 'across channels',
    icon: Rocket,
    x: 85,
    y: 50
  }, {
    id: 3,
    label: 'Capture',
    sub: 'behavior',
    icon: Target,
    x: 50,
    y: 85
  }, {
    id: 4,
    label: 'Improve',
    sub: 'continuously',
    icon: TrendingUp,
    x: 15,
    y: 50
  }];
  return <div className="slide-content relative" data-id="element-66">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-67">
        <h1 className="slide-headline" data-id="element-68">
          Not a format.{' '}
          <span className="text-roche-red" data-id="element-69">A learning system.</span>
        </h1>
      </motion.div>

      <div className="flex-1 flex items-center justify-center relative mt-8" data-id="element-70">
        <div className="w-full max-w-3xl aspect-square relative" data-id="element-71">
          {/* SVG Arrows */}
          <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100" data-id="element-72">
            <defs data-id="element-73">
              <marker id="arrowhead" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto" data-id="element-74">
                <polygon points="0 0, 6 3, 0 6" fill="var(--roche-red)" opacity="0.5" data-id="element-75" />
              </marker>
            </defs>

            {/* Top Right Arc */}
            <motion.path d="M 60 20 A 40 40 0 0 1 80 40" fill="none" stroke="var(--roche-red)" strokeWidth="0.5" strokeDasharray="2 2" markerEnd="url(#arrowhead)" initial={{
            pathLength: 0,
            opacity: 0
          }} animate={{
            pathLength: 1,
            opacity: 0.5
          }} transition={{
            duration: 1,
            delay: 0.5
          }} data-id="element-76" />
            {/* Bottom Right Arc */}
            <motion.path d="M 80 60 A 40 40 0 0 1 60 80" fill="none" stroke="var(--roche-red)" strokeWidth="0.5" strokeDasharray="2 2" markerEnd="url(#arrowhead)" initial={{
            pathLength: 0,
            opacity: 0
          }} animate={{
            pathLength: 1,
            opacity: 0.5
          }} transition={{
            duration: 1,
            delay: 1.5
          }} data-id="element-77" />
            {/* Bottom Left Arc */}
            <motion.path d="M 40 80 A 40 40 0 0 1 20 60" fill="none" stroke="var(--roche-red)" strokeWidth="0.5" strokeDasharray="2 2" markerEnd="url(#arrowhead)" initial={{
            pathLength: 0,
            opacity: 0
          }} animate={{
            pathLength: 1,
            opacity: 0.5
          }} transition={{
            duration: 1,
            delay: 2.5
          }} data-id="element-78" />
            {/* Top Left Arc */}
            <motion.path d="M 20 40 A 40 40 0 0 1 40 20" fill="none" stroke="var(--roche-red)" strokeWidth="0.5" strokeDasharray="2 2" markerEnd="url(#arrowhead)" initial={{
            pathLength: 0,
            opacity: 0
          }} animate={{
            pathLength: 1,
            opacity: 0.5
          }} transition={{
            duration: 1,
            delay: 3.5
          }} data-id="element-79" />
          </svg>

          {/* Nodes */}
          {nodes.map((node, index) => {
          const Icon = node.icon;
          return <motion.div key={node.id} className="absolute w-40 h-40 -ml-20 -mt-20 flex flex-col items-center justify-center bg-white rounded-full shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-gray-100 z-10" style={{
            left: `${node.x}%`,
            top: `${node.y}%`
          }} initial={{
            scale: 0,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 20,
            delay: index * 1
          }} data-id="element-80">
                <div className="text-roche-red mb-2" data-id="element-81">
                  <Icon className="w-8 h-8" data-id="element-82" />
                </div>
                <div className="font-bold text-lg" data-id="element-83">{node.label}</div>
                <div className="text-xs text-text-muted text-center px-2 leading-tight mt-1" data-id="element-84">
                  {node.sub}
                </div>
              </motion.div>;
        })}
        </div>

        {/* Side Note */}
        <motion.div className="absolute right-0 bottom-20 max-w-xs text-right" initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 4.5
      }} data-id="element-85">
          <p className="text-xl text-text-muted italic border-r-4 border-roche-red pr-4 py-2" data-id="element-86">
            Every engagement is a lesson learned
          </p>
        </motion.div>
      </div>
    </div>;
}